import { RefObject, useCallback, useEffect, useState } from "react";
import { TextArea } from "@newsela/angelou";
import {
  labelCss,
  textAreaCss,
  textAreaWrapperCss,
} from "./LearningObjectiveTextArea.style";

interface LearningObjectiveTextAreaProps {
  error: string;
  value: string;
  onChange: (value: string) => void;
  textAreaWrapperRef: RefObject<HTMLDivElement>;
}

const LearningObjectiveTextArea = ({
  error,
  value,
  onChange,
  textAreaWrapperRef,
}: LearningObjectiveTextAreaProps) => {
  const [touched, setTouched] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value);
  };

  const handleBlur = useCallback(() => {
    if (!touched) setTouched(true);
  }, [touched]);

  useEffect(() => {
    // Ensure the error shows after submit even if the user never blurred
    if (error && !touched) setTouched(true);
  }, [error, touched]);

  return (
    <div css={textAreaWrapperCss} tabIndex={-1} ref={textAreaWrapperRef}>
      <TextArea
        __cssFor={{ labelText: labelCss, text: textAreaCss }}
        maxLength={500}
        error={error}
        label="Learning objective"
        isRequired
        placeholder="In this lesson I want my students to..."
        resize="vertical"
        value={value}
        touched={touched}
        onBlur={handleBlur}
        onChange={handleChange}
        dataProps={{
          "data-qa-selector": "lesson-planner-learning-objective-textarea",
        }}
      />
    </div>
  );
};

export default LearningObjectiveTextArea;
